import api from './api';

/**
 * Builds a standard CRUD service bound to a resource path, e.g.
 *   const currencyService = createCrudService('/currencies');
 */
export default function createCrudService(path) {
  return {
    list: (search) =>
      api.get(path, { params: search ? { search } : {} }).then((r) => r.data),
    get: (id) => api.get(`${path}/${id}`).then((r) => r.data),
    create: (payload) => api.post(path, payload).then((r) => r.data),
    update: (id, payload) => api.put(`${path}/${id}`, payload).then((r) => r.data),
    remove: (id) => api.delete(`${path}/${id}`).then((r) => r.data),
  };
}
